import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
// import axios from 'axios' 
// 根据环境设置不同的baseURL
// axios.defaults.baseURL="http://localhost:8080"
// axios.defaults.baseURL = process.env.NODE_ENV === 'production' 
//   ? 'https://www.hnyxnb.top' 
//   : 'http://localhost:8080'
Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
